import { Box, Paper } from '@mui/material';
import { slate } from '../../../theme/theme';

/**
 * AuthShell — centered card on a branded gradient backdrop, used by the
 * secondary auth pages (reset password, activate account, verification).
 */
const AuthShell = ({ children, maxWidth = 420 }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 3,
      position: 'relative',
      overflow: 'hidden',
      background: `linear-gradient(160deg, ${slate[900]} 0%, ${slate[800]} 55%, ${slate[700]} 100%)`,
    }}
  >
    <Box sx={{ position: 'absolute', top: -140, right: -140, width: 420, height: 420, borderRadius: '50%', background: 'radial-gradient(circle, rgba(225,4,4,0.16) 0%, transparent 65%)' }} />
    <Box sx={{ position: 'absolute', bottom: -160, left: -120, width: 460, height: 460, borderRadius: '50%', background: 'radial-gradient(circle, rgba(143,163,173,0.13) 0%, transparent 65%)' }} />

    <Box sx={{ maxWidth, width: '100%', position: 'relative', zIndex: 1 }}>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Box sx={{ display: 'inline-flex', bgcolor: 'rgba(255,255,255,0.92)', borderRadius: 2, px: 2, py: 1 }}>
          <Box component="img" src="/assets/pp-logo.png" alt="PRO Portal" sx={{ height: 36 }} />
        </Box>
      </Box>
      <Paper elevation={0} sx={{ p: 4, borderRadius: 3, boxShadow: '0 12px 40px rgba(0,0,0,0.35)' }}>
        {children}
      </Paper>
    </Box>
  </Box>
);

export default AuthShell;
